export enum TAssetOperationTypeEnum {
  AssetCreated = 'ASSET_CREATED',
  AssetUpdated = 'ASSET_UPDATED',
  AssetDeleted = 'ASSET_DELETED',
  AssetLocked = 'ASSET_LOCKED',
  AssetUnlocked = 'ASSET_UNLOCKED',
  AssetLinked = 'ASSET_LINKED',
  AssetUnlinked = 'ASSET_UNLINKED',
  AssetLinkUpdated = 'ASSET_LINK_UPDATED',
}
